<template>
  <div id="transport-in-step">
    <app-form-header :title="$t('form.steps.transport.title_1_nodpd')" v-if="dpd_excluded_types.includes(claim_form.device_model.invent_model_kind)"></app-form-header>
    <app-form-header :title="$t('form.steps.transport.title_1')" v-else></app-form-header>

    <div id="transport-in-options">
      <app-form-transport-eco-in
        v-if="claim_form.device_model.is_large_size === true" />
      <app-form-transport-standard-in v-else />
    </div>

  </div>
</template>

<script>
import { useDisplay } from "vuetify";
import { computed } from "vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TransportInStep",
  setup() {
    const { name } = useDisplay();
    // eslint-disable-next-line vue/return-in-computed-property
    const classes = computed(() => {
      // name is reactive and
      // must use .value
        const isModal = window.self !== window.top;
          switch (name.value) {
            case "xs":
              return {
                top_padding: (isModal)?0:2,
                density: "compact",
                title: ["title-xs", "pa-2"],
              };
            case "sm":
              return {
                top_padding: (isModal)?0:3,
                density: "comfortable",
                title: ["title-sm", "pa-4"],
              };
            default:
              return {
                top_padding: (isModal)?0:4,
                density: (isModal)?"compact":"default",
                title: ["ccs-title", "pa-5"],
              };
          }

    });
    return { classes };
    },
    data() {
      return {
        dpd_excluded_types: ["Hulajnoga", "ECO GABARYT"]
      }
    },
  computed: {
    ...mapGetters("ClaimForm", { claim_form: "claim_form" }),
  },
  methods: {
    ...mapActions("ClaimForm", {
      updateClaimForm: "updateClaimForm",
      syncValue: "syncValue",
    }),
  },
};
</script>

<style></style>
